import React from "react";
import styled from "styled-components";

const Container = styled.p`
  font-size: 1.4rem;
  line-height: 2.3rem;
  text-align: left;
  margin-top: 40px;
`;

function SupportSEPAPaymentMandate() {
  return (
    <Container>
      En fournissant vos informations de paiement et en confirmant ce paiement,
      vous autorisez (A) Le Média et Stripe, notre prestataire de paiement, à
      envoyer des instructions à votre banque pour débiter votre compte, et (B)
      votre banque à débiter votre compte conformément à ces instructions. Dans
      le cadre de vos droits, vous avez la possibilité de demander un
      remboursement de votre banque dans les termes et les conditions de votre
      contrat avec votre banque. Un remboursement doit être réclamé dans les 8
      semaines à compter de la date à laquelle votre compte a été débité. Vos
      droits sont expliqués dans une déclaration que vous pouvez obtenir auprès
      de votre banque. Vous acceptez de recevoir des notifications pour les
      futurs débits jusqu'à 2 jours avant qu'ils ne surviennent.
    </Container>
  );
}

export default SupportSEPAPaymentMandate;
